import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  public showHeader: BehaviorSubject<boolean>;

  constructor() {
    this.showHeader = new BehaviorSubject(true);
  }

  public hide() {
    this.showHeader.next(false);
  }

  public display() {
    this.showHeader.next(true);
  }
}
